import { render, staticRenderFns } from "./SelectGrid.vue?vue&type=template&id=56c67f20"
import script from "./SelectGrid.vue?vue&type=script&lang=js"
export * from "./SelectGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports